<template>
  <div>
    <!--Date : Datepicker.-->
    <label class="control-label">{{ pieceName }}</label>
    <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>

    <date-picker
      v-model="dateSelected"
      lang="en"
      :type="timeEditable ? 'datetime' : 'date'"
      :width="timeEditable ? 200 : 120"
      input-class="form-control"
      :format="timeEditable ? 'MM/DD/YYYY hh:mm A' : 'MM/DD/YYYY'"
      :confirm="true"
      :clearable="false"
      :not-before="minDate"
      :time-picker-options="timeEditable ? {start: '00:00', step: '00:60', end: '24:00'} : undefined"
    >
    </date-picker>
    <input type="hidden" :name="'pieces[' + pieceIndex + '][content]'" :value="pieceContentValue" />

    <div class="step-spacer"></div>
  </div>
</template>

<script>
import utils from '../../../../mixins/utils';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'date-piece',
  components: {DatePicker},
  mixins: [utils],
  data() {
    const minDate = moment().add(1, 'hour').startOf('hour').toDate();

    return {
      minDate,
      dateSelected: new Date(minDate),
    };
  },
  props: {
    pieceIndex: {
      type: Number,
      required: true,
    },
    pieceName: {
      type: String,
      required: true,
    },
    pieceContent: {
      type: String,
      required: true,
    },
    pieceOptions: {
      type: Object,
      required: true,
    },
  },
  computed: {
    pieceContentValue() {
      return this.dateSelected ? moment(this.dateSelected).format(this.contentFormat) : '';
    },
    contentFormat() {
      return this.pieceOptions.format || (this.timeEditable ? 'LLL' : 'LL');
    },
    timeEditable() {
      return this.pieceOptions.time_editable;
    },
  },
  mounted() {
    if (this.pieceContent) {
      this.dateSelected = moment(this.pieceContent, [this.contentFormat, 'LLL']).toDate();
    }
  },
};
</script>

<style lang="scss" scoped></style>
